module.exports = __webpack_public_path__ + "static/media/logo.abd5b61d.png";